<template>
    <div class="error-component">
        <icon type="solid" name="faTriangleExclamation" aria-hidden="true" focusable="false"></icon>
        <div v-if="errorMessage" class="message">
            <span>{{ errorMessage }}</span>
        </div>
    </div>
</template>

<script>
import script from './Error';
    export default script;</script>

<style lang="less">
    @import "./Error.less";
</style>